<app-header></app-header>
<div class="content">
<div class="h-100-percent max-width-lg">
    <section class="flex flex-col items-center">
        <img class="mt-80"src="/assets/images/unauthorized.png">
        <div class="fw-500 fs-20 font-color mt-62"> {{ 'NOTIFICATIONS.AUTHORIZED_ACCESS' | transloco }} </div>
        <div class="fw-500 fs-20 font-color mb-20">Please contact Foundation Administrator SaaS_Foundation_Support&#64;temenos.com for support </div>
        <button class="accent ml-16" (click)="logout()">{{'MY_ACCOUNT.LOGOUT' | transloco}}</button>
    </section>
    </div>
</div>
<app-footer class="footer"></app-footer> 
  